export const APP_NAME_GENERIC = 'Openfund';
export const DESO_APP_NAME = 'DeSo';
export const DESO_TOKEN_NAME = `${DESO_APP_NAME} Token`;
export const FOCUS_TOKEN_DISPLAY_NAME = 'FOCUS';
export const FOCUS_TOKEN_USERNAME = 'Focus';
export const DESO_TOKEN = '$DESO';
export const DESO_TOKEN_DISPLAY_NAME = 'DESO';

export enum THEME_OPTIONS {
  lightMode = 'light',
  darkMode = 'dark',
  paperLightMode = 'paper-light',
  paperDarkMode = 'paper-dark',
  modernLightMode = 'modern-light',
  modernDarkMode = 'modern-dark',
  radarLightMode = 'radar-light',
  radarDarkMode = 'radar-dark',
}

export const LOCAL_STORAGE_KEYS = {
  theme: 'openfund-app/theme/v1',
  showTokensAlert: 'openfund-app/tokens-alert/v1',
};

export const FOCUS_TOKEN_SUPPLY = 44_663_577_756;

export const ONE_TRILLION = 1_000_000_000_000;

export const LARGE_WIDTH_BREAKPOINT = 1024;

export enum CREATOR_COIN_TYPES {
  creator = 'creator',
  meme = 'meme',
  custom = 'custom',
}

export enum AssociationDeSoTokenWhitelistValue {
  DeSoTokenWhitelistAssociationKey = 'DeSoTokenWhitelistAssociationKey',
}
